var map = {
	"./quiz_stage_10_bg_mobile.svg": "2EUo",
	"./quiz_stage_11_bg_mobile.svg": "v1Ar",
	"./quiz_stage_1_bg_mobile.svg": "cXlo",
	"./quiz_stage_2_bg_mobile.svg": "WYzi",
	"./quiz_stage_3_bg_mobile.svg": "usKi",
	"./quiz_stage_4_bg_mobile.svg": "T0jC",
	"./quiz_stage_5_bg_mobile.svg": "lSms",
	"./quiz_stage_6_bg_mobile.svg": "EQSq",
	"./quiz_stage_7_bg_mobile.svg": "+g1Q",
	"./quiz_stage_8_bg_mobile.svg": "jI0N",
	"./quiz_stage_9_bg_mobile.svg": "orSF"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Wi0G";